import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CustomRoles = lazy(() =>
  import("@scenes/PermissionSettings/components/CustomRoles/CustomRolesWrapper").then((module) => ({
    default: module.CustomRolesWrapper,
  }))
);

export const permissionSettingsRolesNRO: NavigationRoutingObject = {
  Component: CustomRoles,
  componentFeatureFlippers: ["unified_permission_settings_page"],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("roles-nro-heading", "Roles"),
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("company", {
      permission: "manageCompanySettings",
    });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/permission_settings/roles/:appGroupId",
};
